import { useState, useEffect } from "react";
import 'aos/dist/aos.css'; // Import AOS styles
import AOS from 'aos'; // Import AOS library
import { Helmet } from "react-helmet";
import "../css/PoemsEnglish.css";
import { Viyog } from "../components/PoemMarathi/Viyog";
import { KshanbhangurPremsari } from "../components/PoemMarathi/KshanbhangurPremsari";
import { Premanubandh } from "../components/PoemMarathi/Premanubandh";
import { TujhyatRangleleAstitva } from "../components/PoemMarathi/TujhyatRangleleAstitva";
import { TujhachMiTharlo } from "../components/PoemMarathi/TujhachMiTharlo";


export const PoemsMarathi = () => {
    // State to manage the visibility of each modal
    const [showViyog, setShowViyog] = useState(false);
    const [showKshanbhangurPremsari, setShowKshanbhangurPremsari] = useState(false);
    const [showPremanubandh, setShowPremanubandh] = useState(false);
    const [showTujhyatRangleleAstitva, setShowTujhyatRangleleAstitva] = useState(false);
    const [showTujhachMiTharlo, setShowTujhachMiTharlo] = useState(false);
    useEffect(() => {
        AOS.init({
            duration: 1000, // Animation duration in milliseconds
            easing: 'ease-in-out', // Animation easing
            once: false, // Only animate once
        });
    }, []);

    return (
        <>
            <Helmet>
                <title>Privacy Policy | Lone Wolf Writes</title>
                <meta name="description" content=" कविता | Lone Wolf Writes" />
                <link rel="canonical" href="https://lonewolfwrites.com/poems-mar" />
            </Helmet>
            <main>
                <div className="container">
                    <h1 style={{ textAlign: "center", fontSize: "largest", marginBottom: "40px" }}>कविता</h1>
                    <div className="row mt-4">
                        <div className="col-md-6 mb-4" data-aos="fade-down" data-aos-delay="100">
                            <div className="card" style={{ border: "none", }}>
                                <div className="poemeng">
                                    <button className="btn btn-primary" style={{ backgroundColor: "transparent", border: "none", color: "red" }} onClick={() => setShowKshanbhangurPremsari(true)} >
                                        <picture><img className="img-fluid rounded" src="/media/poemsmar/kshanbhar-premsari.jpg" alt=" क्षणभंगुर प्रेमसरी | Lone Wolf writes " style={{ width: "100%", border: "none", height: "450px", objectFit: "cover" }} /></picture><br />
                                        क्षणभंगुर प्रेमसरी
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="row">
                                <div className="col-md-6 mb-2" data-aos="fade-up" data-aos-delay="200">
                                    <div className="card" style={{ border: "none", }}>
                                        <div className="poemeng">
                                            <button className="btn btn-primary" style={{ backgroundColor: "transparent", border: "none", color: "red" }} onClick={() => setShowPremanubandh(true)} >
                                                <picture><img className="img-fluid rounded" src="/media/poemsmar/premanubandh.jpg" alt=" प्रेमानुबंध | Lone Wolf writes " style={{ width: "100%", border: "none", height: "200px", objectFit: "cover" }} /></picture><br />
                                                प्रेमानुबंध
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 mb-4" data-aos="fade-up" data-aos-delay="300">
                                    <div className="card" style={{ border: "none", }}>
                                        <div className="poemeng">
                                            <button className="btn btn-primary" style={{ backgroundColor: "transparent", border: "none", color: "red" }} onClick={() => setShowTujhyatRangleleAstitva(true)} >
                                                <picture><img className="img-fluid rounded" src="/media/poemsmar/tujhyat-ranglele-majhe-astitva.jpg" alt=" तुझ्यात रंगलेले माझे अस्तित्व | Lone Wolf writes " style={{ width: "100%", border: "none", height: "200px", objectFit: "cover", margin: "auto" }} /></picture><br />
                                                तुझ्यात रंगलेले माझे अस्तित्व
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6 mb-2" data-aos="fade-up" data-aos-delay="200">
                                    <div className="card" style={{ border: "none", }}>
                                        <div className="poemeng">
                                            <button className="btn btn-primary" style={{ backgroundColor: "transparent", border: "none", color: "red" }} onClick={() => setShowViyog(true)} >
                                                <picture><img className="img-fluid rounded" src="/media/poemsmar/viyog.jpg" alt=" वियोग | Lone Wolf writes " style={{ width: "100%", border: "none", height: "200px", objectFit: "cover" }} /></picture><br />
                                                वियोग
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 mb-4" data-aos="fade-up" data-aos-delay="300">
                                    <div className="card" style={{ border: "none", }}>
                                        <div className="poemeng">
                                            <button className="btn btn-primary" style={{ backgroundColor: "transparent", border: "none", color: "red" }} onClick={() => setShowTujhachMiTharlo(true)} >
                                                <picture><img className="img-fluid rounded" src="/media/poemsmar/tujhach-me-tharlo.jpg" alt=" तुझाच मी ठरलो | Lone Wolf writes " style={{ width: "100%", border: "none", height: "200px", objectFit: "cover" }} /></picture><br />
                                                तुझाच मी ठरलो
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>

            {/* Modals */}
            {showViyog && <Viyog onClose={() => setShowViyog(false)} />}
            {showKshanbhangurPremsari && <KshanbhangurPremsari onClose={() => setShowKshanbhangurPremsari(false)} />}
            {showPremanubandh && <Premanubandh onClose={() => setShowPremanubandh(false)} />}
            {showTujhyatRangleleAstitva && <TujhyatRangleleAstitva onClose={() => setShowTujhyatRangleleAstitva(false)} />}
            {showTujhachMiTharlo && <TujhachMiTharlo onClose={() => setShowTujhachMiTharlo(false)} />}
        </>
    );
};
